import scheduleTeamPickerPaneStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_IS_TEAM_PICKER_PANE_DATA_LOADING', function setIsTeamPickerPaneDataLoading(isLoading: boolean) {
    scheduleTeamPickerPaneStore.isDataLoading = isLoading;
});
